var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames, cPointAtOrigin } from '@shapeable/utils';
var cls = classNames('svg-donut-slice');
import { lighten } from 'polished';
import { animated, useSpring, to } from '@react-spring/web';
export var SvgDonutSliceDefaultProps = {
  outerRadius: 600,
  innerRadius: 200,
  color: 'black',
  duration: 1000,
  highlightOnHover: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ShapeStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    transition: fill 0.2s;\n    ", "\n\n    ", "\n\n  "], ["\n    transition: fill 0.2s;\n    ", "\n\n    ", "\n\n  "])), function (_a) {
    var _color = _a._color,
      isClickable = _a.isClickable;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      fill: ", ";\n      cursor: ", ";\n    "], ["\n      fill: ", ";\n      cursor: ", ";\n    "])), _color, isClickable ? 'pointer' : 'default');
  }, function (_a) {
    var highlightOnHover = _a.highlightOnHover,
      _color = _a._color;
    return highlightOnHover && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n       &:hover {\n        fill: ", ";\n      }\n    "], ["\n       &:hover {\n        fill: ", ";\n      }\n    "])), lighten(0.05, _color));
  })
});
// -------- Components -------->
var My = {
  Container: styled(animated.svg)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Path: styled(animated.path)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ShapeStyles)
};
export var SvgDonutSlice = function (props) {
  var className = props.className,
    outerRadius = props.outerRadius,
    innerRadius = props.innerRadius,
    id = props.id,
    color = props.color,
    style = props.style,
    onClick = props.onClick,
    headAngle = props.headAngle,
    tailAngle = props.tailAngle,
    startHeadAngle = props.startHeadAngle,
    startTailAngle = props.startTailAngle,
    duration = props.duration,
    children = props.children,
    highlightOnHover = props.highlightOnHover;
  var size = outerRadius * 2;
  var originX = outerRadius;
  var originY = outerRadius;
  var segmentRadius = (outerRadius - innerRadius) / 2;
  var cPointAt = cPointAtOrigin(originX, originY);
  var hasStartingValues = startHeadAngle !== undefined && startTailAngle !== undefined;
  var values = !hasStartingValues ? {
    headAngle: headAngle,
    tailAngle: tailAngle
  } : useSpring({
    from: {
      headAngle: startHeadAngle,
      tailAngle: startTailAngle
    },
    to: {
      headAngle: headAngle,
      tailAngle: tailAngle
    },
    config: {
      tension: 130,
      friction: 13,
      bounce: 0
    },
    //  config: { duration, easing: easings.easeOutCirc  },
    onRest: props.onRest
  });
  var shapeDef = function (headAngle, tailAngle) {
    // define the major points along the path. The shape we're building is shown in Figma here:
    // https://www.figma.com/file/mchQRDH6rkPA9ufK91Glbt/ADSW?type=design&node-id=1136-13476&mode=design&t=DWWEg9BwCrCcvKZT-4
    var tailCutoutStart = cPointAt(innerRadius, tailAngle);
    var tailCutoutEnd = cPointAt(outerRadius, tailAngle);
    var headStart = cPointAt(outerRadius, headAngle);
    var headEnd = cPointAt(innerRadius, headAngle);
    // the large arc flag needs to change depending on the angle difference between the tail and head
    // else it produces incorrect arcs for angles > 180 degrees
    var difference = headAngle - tailAngle;
    return "\n      M".concat(tailCutoutStart.cx, ",").concat(tailCutoutStart.cy, " \n      A").concat(segmentRadius, " ").concat(segmentRadius, " 0 0 0 ").concat(tailCutoutEnd.cx, " ").concat(tailCutoutEnd.cy, " \n      A").concat(outerRadius, " ").concat(outerRadius, " 0 ").concat(difference > 180 ? "1" : "0", " 1 ").concat(headStart.cx, " ").concat(headStart.cy, "\n      A").concat(segmentRadius, " ").concat(segmentRadius, " 0 1 1 ").concat(headEnd.cx, " ").concat(headEnd.cy, "\n      A").concat(innerRadius, " ").concat(innerRadius, " 0 ").concat(difference > 180 ? "1" : "0", " 0 ").concat(tailCutoutStart.cx, " ").concat(tailCutoutStart.cy, " z\n    ");
  };
  return React.createElement(My.Container, {
    width: size,
    height: size,
    id: "slice-".concat(id),
    style: style,
    _color: color,
    className: cls.name(className),
    viewBox: "0 0 ".concat(size, " ").concat(size)
  }, React.createElement(My.Path, {
    highlightOnHover: highlightOnHover,
    _color: color,
    isClickable: !!onClick,
    d: to([values.headAngle, values.tailAngle], shapeDef),
    onClick: onClick,
    className: "shape"
  }), children);
};
SvgDonutSlice.cls = cls;
SvgDonutSlice.defaultProps = SvgDonutSliceDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;